import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { cachedSerialNames31jc5fovi62px as cachedSerialNames } from './Platform.common.mjs';
import { SerialDescriptor2pelqekb5ic3a as SerialDescriptor } from '../descriptors/SerialDescriptor.mjs';
import { CachedNames2minxlyafeo07 as CachedNames } from './CachedNames.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var NullableSerializerClass;
function NullableSerializer() {
  if (NullableSerializerClass === VOID) {
    class $ {
      constructor(serializer) {
        this.z1b_1 = serializer;
        this.a1c_1 = new (SerialDescriptorForNullable())(this.z1b_1.az());
      }
      az() {
        return this.a1c_1;
      }
      b1c(encoder, value) {
        if (!(value == null)) {
          encoder.f15();
          encoder.nz(this.z1b_1, value);
        } else {
          encoder.g14();
        }
      }
      oz(encoder, value) {
        return this.b1c(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
      }
      pz(decoder) {
        return decoder.x12() ? decoder.qz(this.z1b_1) : decoder.y12();
      }
      equals(other) {
        if (this === other)
          return true;
        if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
          return false;
        if (!(other instanceof NullableSerializer()))
          THROW_CCE();
        if (!equals(this.z1b_1, other.z1b_1))
          return false;
        return true;
      }
      hashCode() {
        return hashCode(this.z1b_1);
      }
    }
    initMetadataForClass($, 'NullableSerializer', VOID, VOID, [KSerializer()]);
    NullableSerializerClass = $;
  }
  return NullableSerializerClass;
}
var SerialDescriptorForNullableClass;
function SerialDescriptorForNullable() {
  if (SerialDescriptorForNullableClass === VOID) {
    class $ {
      constructor(original) {
        this.m11_1 = original;
        this.n11_1 = this.m11_1.h10() + '?';
        this.o11_1 = cachedSerialNames(this.m11_1);
      }
      h10() {
        return this.n11_1;
      }
      t12() {
        return this.o11_1;
      }
      l11() {
        return true;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SerialDescriptorForNullable()))
          return false;
        if (!equals(this.m11_1, other.m11_1))
          return false;
        return true;
      }
      toString() {
        return toString(this.m11_1) + '?';
      }
      hashCode() {
        return imul(hashCode(this.m11_1), 31);
      }
      s11() {
        return this.m11_1.s11();
      }
      t11() {
        return this.m11_1.t11();
      }
      u11() {
        return this.m11_1.u11();
      }
      bz() {
        return this.m11_1.bz();
      }
      v11(index) {
        return this.m11_1.v11(index);
      }
      w11(name) {
        return this.m11_1.w11(name);
      }
      x11(index) {
        return this.m11_1.x11(index);
      }
      y11(index) {
        return this.m11_1.y11(index);
      }
      z11(index) {
        return this.m11_1.z11(index);
      }
    }
    initMetadataForClass($, 'SerialDescriptorForNullable', VOID, VOID, [SerialDescriptor(), CachedNames()]);
    SerialDescriptorForNullableClass = $;
  }
  return SerialDescriptorForNullableClass;
}
//region block: exports
export {
  NullableSerializer as NullableSerializer41etqlj0tdq5,
  SerialDescriptorForNullable as SerialDescriptorForNullable2slcv65za9oog,
};
//endregion

//# sourceMappingURL=NullableSerializer.mjs.map
